module.exports = "/assets/dist/images/bodystyles_vans.png?b9ed79a1900e9044dd2918b2d4173e26";